import { combineReducers } from 'redux';

import dependencyTemplateReducer from './DependencyInstaller/reducer';
import gameTemplateReducer from './GameTemplate/reducer';
import hostTemplateReducer from './HostCapacity/reducer';
import utilityTemplateReducer from './UtilityTemplate/reducer';

const deploymentTemplateReducer = combineReducers({
  gameTemplateReducer,
  utilityTemplateReducer,
  dependencyTemplateReducer,
  hostTemplateReducer,
});

export default deploymentTemplateReducer;
